import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from 'store/app/entities/baseQuery';
import { analyticsApi } from 'store/app/entities/AnalyticsSlice';

const initiativesEndpoints = build => ({
  listInitiatives: build.query({
    query: ({ search } = {}) => {
      const params = typeof search === 'string' && search.trim() ? { search: search.trim() } : {};
      const qs = new URLSearchParams(params).toString();
      return { url: `v1/initiative${qs ? `?${qs}` : ''}` };
    },
    transformResponse: response => (Array.isArray(response) ? response : (response?.data ?? [])),
    providesTags: [{ type: 'Initiatives', id: 'LIST' }],
  }),
  createInitiative: build.mutation({
    query: body => ({ url: 'v1/initiative', method: 'POST', body }),
    transformResponse: response => response?.data ?? response,
    invalidatesTags: [{ type: 'Initiatives', id: 'LIST' }],
  }),
  updateInitiative: build.mutation({
    query: ({ id, body }) => ({ url: `v1/initiative/${id}`, method: 'PATCH', body }),
    transformResponse: response => response?.data ?? response,
    invalidatesTags: (result, error, { id }) => [
      { type: 'Initiatives', id: 'LIST' },
      { type: 'Initiatives', id },
    ],
    async onQueryStarted({ dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
        dispatch(analyticsApi.util.invalidateTags([{ type: 'AnalyticsChart' }]));
      } catch {
        // ignore
      }
    },
  }),
});

const api = createApi({
  reducerPath: 'initiativesApi',
  baseQuery,
  tagTypes: ['Initiatives'],
  endpoints: initiativesEndpoints,
});

export const {
  useListInitiativesQuery,
  useLazyListInitiativesQuery,
  useCreateInitiativeMutation,
  useUpdateInitiativeMutation,
} = api;
export const { middleware: initiativesMiddleware, reducer: initiativesReducer } = api;
